import React, { useMemo, useState } from 'react';
import { useWindowDimensions } from 'react-native';
import { ICarouselInstance } from 'react-native-reanimated-carousel';

import constants from '../../../../Config/constants';
import { useGetAdsQuery } from '../../../../RTK/api/ads';

import { CARD_HEIGHT_BIG } from './constants';

const EMPTY_ARRAY = [];

const useExclusiveBannerController = () => {
  const carouselRef = React.useRef<ICarouselInstance>(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const { width } = useWindowDimensions();

  const { data, isFetching } = useGetAdsQuery({
    payload: { limit: 5, category: ['event'] },
  });

  const _onPressPagination = (index: number) => {
    setActiveSlide(index);
    carouselRef.current.scrollTo({ index: index, animated: true });
  };

  const carouselHeight = useMemo(
    () => (width <= 767 ? 600 : CARD_HEIGHT_BIG),
    [width],
  );

  const carouselWidth = useMemo(() => {
    const maxWidth =
      width >= constants.PAGE_MAX_WIDTH ? constants.PAGE_MAX_WIDTH : width;
    const spacing = width <= 576 ? 40 : 80; // 40 is spacing on left and right on mobile, 80 on web
    return maxWidth - spacing;
  }, [width]);

  return {
    activeSlide,
    carouselHeight,
    carouselRef,
    carouselWidth,
    data: data?.ads || EMPTY_ARRAY,
    isFetching,
    onPressPagination: _onPressPagination,
    setActiveSlide,
  };
};

export default useExclusiveBannerController;
